// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1KnSR","validationTips":"StatementDescriptor_validationTips__2Q5FP"};